<script>
  let themeClass = 'dark'
  function toggleTheme() {
    const htmlClassList = document.documentElement.classList
    if (htmlClassList.contains('light')) {
      // Toggle to dark mode
      htmlClassList.replace('light', 'dark')
      themeClass = 'dark'
    } else {
      // Toggle to light mode
      htmlClassList.replace('dark', 'light')
      themeClass = 'light'
    }
  }
</script>

<div class="navbar">
  <div class="left">
    <a href="/" class="brand">
      <img src="/logo.svg" alt="Squid's logo" class="logo" />
      <div class="brand">
        <h1>Squid</h1>
        <h2>
          <span>Software</span>
          <span>Systems</span>
        </h2>
      </div>
    </a>
    <div class="left-links links">
      <a href="#/solutions"><b>Solutions</b></a>
      <a href="#/contact"><b>Contact</b></a>
    </div>
  </div>
  <div class="right">
    <div class="right-links links">
      <a href="#/solutions"><b>Solutions</b></a>
      <a href="#/contact"><b>Contact</b></a>
    </div>
    <button class="mode" on:click={toggleTheme}>
      {#if themeClass === 'light'}
        <img src="/icons/moon-small.png" alt="moon" class="icon" />
      {:else}
        <img src="/icons/sun-small.png" alt="sun" class="icon sun" />
      {/if}
    </button>
  </div>
</div>

<style>
  .links {
    display: flex;
  }
  @media (max-width: 1000px) {
    .brand {
      margin-left: 10px;
      margin-right: 10px;
    }
    .right-links {
      visibility: visible;
      opacity: 1;
      transition: opacity 0.5s ease-in;
    }
    .left-links {
      visibility: hidden;
      opacity: 0;
      width: 0;
    }
    .links {
      flex-direction: column;
    }
  }
  .links a {
    margin: 5px;
    padding: 0;
  }
  .navbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: clip;
    height: 100px;
    background-color: var(--secondary-background);
    padding: 20px;
  }
  .left,
  .right {
    display: flex;
    align-items: center;
  }
  @media (min-width: 1000px) {
    .left-links {
      visibility: visible;
      opacity: 1;
      transition: opacity 0.5s ease-in;
    }
    .right-links {
      visibility: hidden;
      opacity: 0;
      width: 0;
    }
    .left a {
      padding: 20px;
    }
  }
  .brand {
    display: flex;
    align-items: center;
  }
  .brand h1 {
    padding-left: 20px;
    font-size: 3em;
  }
  .brand h2 {
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    align-items: baseline;
  }
  .mode {
    background-color: transparent;
    border: none;
    display: flex;
    align-items: center;
    margin-right: 30px;
    cursor: pointer;
  }
  .sun {
    filter: invert(78%) sepia(54%) saturate(807%) hue-rotate(345deg) brightness(99%) contrast(105%); /* black -> yellow */
  }
  .logo {
    height: 100px;
  }
  a:hover {
    text-decoration: none;
  }
  @media (max-width: 600px) {
    .logo {
      max-width: 75px;
    }
    .brand h1 {
      font-size: 2.25em;
      padding-left: 0;
    }
    .brand h2 {
      display: none;
    }
    .mode {
      margin-right: 5px;
    }
    .left {
      flex-basis: 67%;
      justify-content: space-between;
    }
    .right {
      flex-basis: 33%;
      justify-content: flex-end;
    }
  }
</style>
